// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../../common/JQueryView';
import DateRangePicker from '../../../common/DateRangePicker';
import dayjs from 'dayjs';

export default class FormView extends JQueryView {
  constructor() {
    super('.simple_form');
    $('.form-group-float').each((index, element) => {
      const control = $(element).find('.form-control');
      if (control.val() && control.val().length !== 0) {
        control.addClass('form-control-active');
      } else {
        control.removeClass('form-control-active');
      }
    });
    this.render();
  }

  @on({ event: 'keydown', selector: '.date-field' })
  preventTypingDate(event: any) {
    const key = event.keyCode;
    if (key === 8) {
      $(event.currentTarget).val('');
    }
    return false;
  }

  @on({ event: 'change', selector: '.form-control' })
  onChangeFormControl(event: any) {
    const target = $(event.target);
    if (target.val().length !== 0) {
      target.find('.form-control').addClass('form-control-active');
    }
  }

  @on({ event: 'blur input', selector: '.form-control' })
  onBlurFormControl(event: any) {
    const target = $(event.target);
    if (target.val().length === 0) {
      target.removeClass('form-control-active');
    } else {
      target.addClass('form-control-active');
    }
  }

  initDateRangePicker(container: any) {
    new DateRangePicker(
      container,
      {
        singleDatePicker: true,
        timePicker: false,
        showDropdowns: true,
        maxDate: dayjs(),
        locale: {
          format: 'YYYY/MM/DD',
        },
      },
      {
        picker: {
          format: {
            start: 'YYYY/MM/DD',
            template: startDate => startDate,
          },
        },
      },
    ).render();
  }

  render() {
    this.initDateRangePicker(this.$el);
  }
}
